"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.BaseCrossChainAdapter = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _types = require("./types");
var _sdkCore = require("@acala-network/sdk-core");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const DEFAULT_TX_CHECKING_TIMEOUT = 2 * 60 * 1000;
class BaseCrossChainAdapter {
  constructor(api, chain, routers) {
    this.routers = void 0;
    this.api = void 0;
    this.chain = void 0;
    this.findAdapter = void 0;
    this.api = api;
    this.chain = chain;
    this.routers = routers;
  }
  injectFindAdapter(func) {
    this.findAdapter = func;
  }
  getRouters() {
    return this.routers.map(i => _objectSpread(_objectSpread({}, i), {}, {
      from: this.chain
    }));
  }
  getSS58Prefix() {
    var _this$api$registry$ch;
    return Number((_this$api$registry$ch = this.api.registry.chainSS58) === null || _this$api$registry$ch === void 0 ? void 0 : _this$api$registry$ch.toString());
  }
  subscribeInputConfigs(params) {
    const {
      to,
      token,
      address
    } = params;
    const toAdapter = this.findAdapter(to);

    // subscribe destination min receive
    const crossChainFee = toAdapter.getCrossChainFee(token);
    const minInput$ = toAdapter.subscribeMinInput(token);
    const maxInput$ = this.subscribeMaxInput(token, address, to);
    return (0, _rxjs.combineLatest)({
      minInput: minInput$,
      maxInput: maxInput$
    }).pipe((0, _operators.map)(_ref => {
      let {
        minInput,
        maxInput
      } = _ref;
      return {
        minInput,
        maxInput,
        ss58Prefix: toAdapter.getSS58Prefix(),
        destCrossChainFee: crossChainFee,
        tokenDecimals: toAdapter.getCrossChainTokenDecimals(token)
      };
    }));
  }
  measureTransferFee(params) {
    let tx = this.createTx(_objectSpread({}, params));
    if (this.api.type === 'rxjs') {
      tx = tx;
      return tx.paymentInfo(params.address).pipe((0, _operators.map)(feeData => {
        return feeData.partialFee.toString();
      }));
    }

    // for promise api
    tx = tx;
    return (0, _rxjs.from)((async () => {
      const feeData = await tx.paymentInfo(params.address);
      return feeData.partialFee.toString();
    })());
  }
  subscribeBalanceChanged(configs) {
    const {
      token,
      address,
      amount,
      tolerance
    } = configs;
    // allow 1% tolerance as default
    const target = amount.mul(new _sdkCore.FixedPointNumber(1 - (tolerance || 0.01)));
    let savedBalance;
    return this.subscribeAvailableBalance(token, address).pipe((0, _rxjs.timeout)(configs.timeout || DEFAULT_TX_CHECKING_TIMEOUT), (0, _operators.map)(balance => {
      if (!savedBalance) {
        savedBalance = balance;
      }
      const diff = balance.minus(savedBalance);
      if (savedBalance && diff.gte(target)) {
        return _types.BalanceChangedStatus.SUCCESS;
      }
      return _types.BalanceChangedStatus.CHECKING;
    }), (0, _operators.catchError)(e => {
      if (e instanceof _rxjs.TimeoutError) {
        return (0, _rxjs.of)(_types.BalanceChangedStatus.TIMEOUT);
      }
      return (0, _rxjs.of)(_types.BalanceChangedStatus.UNKNOWN_ERROR);
    }));
  }
}
exports.BaseCrossChainAdapter = BaseCrossChainAdapter;